import React, { useState, useEffect } from "react";
import Sidebar from "../sidebar/Sidebar";
import axios from "axios";
import api from "../../api/axios";
import SyncLoader from "react-spinners/SyncLoader";
import PopUP from "../Popup/PopUP";
import { toast } from "react-toastify";
function AdminCertificate() {
  //state
  const [sidebarToggle, setSidebarToggle] = useState(true);
  const [, setPayments] = useState([]);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [, setError] = useState(null);
  const [inputdata, setInputdata] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [lodding, setLodding] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [popup, setPopup] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [userdata, setUserdata] = useState([]);
  const [updateID, setUpdateID] = useState(null);
  const today = new Date();
  const date = today.toLocaleDateString("en-GB");
  const fetchuserdata = async () => {
    try {
      setLodding(true);
      const res = await api.get("/getuserdata");
      
      setUserdata(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLodding(false);
    }
  };
  useEffect(() => {
    fetchuserdata();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && isValidFileType(file)) {
      setSelectedFile(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const file = e.dataTransfer.files[0];
    if (file && isValidFileType(file)) {
      setSelectedFile(file);
    }
  };

  const isValidFileType = (file) => {
    const allowedTypes = ["image/png", "image/jpeg", "application/pdf"];
    return allowedTypes.includes(file.type);
  };


  const handlePopup = (id) => {
    setUpdateID(id);
    setPopup(true);
  };

  //sidebar toggle
  const toggleClick = () => {
    setSidebarToggle(!sidebarToggle);
  };



  //for input change
  const handleChange = (e) => {
    setInputdata(e.target.value);
  };

  //fetch data
  useEffect(() => {
    const fetchPayments = async () => {
      try {
        setLodding(true);
        const response = await api.get("/payments");
        setTimeout(() => {
          setLodding(false);
        }, 2000);
        setPayments(response.data.items || []);

        const fetchedPayment = response.data.items || [];
        const savepayments = JSON.parse(localStorage.getItem("payments")) || [];

        const mergePayment = fetchedPayment.map((payment) => {
          const savePayment = savepayments.find((p) => p.id === payment.id);
          return savePayment
            ? { ...payment, statuus: savePayment.statuus }
            : payment;
        });
        setPayments(mergePayment);

        localStorage.setItem("payments", JSON.stringify(mergePayment));
        localStorage.setItem("payment", JSON.stringify(response.data));
      } catch (err) {
        setError(err.message);
      } finally {
        setLodding(false);
      }
    };
    fetchPayments();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    const fdata = userdata.filter((user) => {
      const firstName = user?.notes?.first_name?.toString() || "";
      const lastName = user?.notes?.last_name?.toString() || "";
      const date = user?.date?.toString() || "";
      return (
        firstName.includes(inputdata) ||
        lastName.includes(inputdata) ||
        date.includes(inputdata)
      );
    });

    setFilteredPayments(fdata);
  };

  //pagination
  const recordPerPage = 10;
  const lastIndex = currentPage * recordPerPage;
  const firstIndex = lastIndex - recordPerPage;
  const records = userdata.slice(firstIndex, lastIndex);
  const npage = Math.ceil(userdata.length / recordPerPage);

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const nextPage = () => {
    if (currentPage < npage) setCurrentPage(currentPage + 1);
  };

  //refresh
  const handleRefresh = () => {
    setInputdata("");
    setFilteredPayments([]);
    setCurrentPage(1);
  };

  const handlePDFupload = async (e) => {
    e.preventDefault();
    setPopup(false);
    try {
      const formData = new FormData();
      formData.append("selectedFile", selectedFile);
      formData.append("date", date);
      await api.put(
        `/update/${updateID}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      await fetchuserdata();
      toast.success("Certificate Upload successfull..");
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {/* header section-1 */}
      <div className="font-[Poppins] flex ">
        {sidebarToggle ? <div className="w-[320px] nirav"></div> : null}
        <Sidebar toggleClick={toggleClick} sidebarToggle={sidebarToggle} />
        <div className="w-[100%] ">
          <div className=" 2xl:w-[90%] w-[95%] m-auto 2xl:mt-16 mt-10  xl:p-2 lg:p-10  p-2">
            <div className="sm:flex sm:justify-between sm:items-center">
              <h1 className="font-medium 2xl:text-2xl text-xl">
                Hello admin{} 👋🏼
              </h1>
            </div>

            {/* section-3 */}
            <div className="border 2xl:mt-10 mt-7 2xl:rounded-[30px] rounded-[20px] px-10 py-8  bg-white shadow-sm">
              <div className="mx-2 my-2 flex flex-wrap justify-between items-center">
                <div className="mb-3">
                  <h1 className="font-semibold 2xl:text-2xl text-xl">
                    Certificates
                  </h1>
                  {/* <h6 className="text-[#C65B1D] font-normal mt-1 max-2xl:text-sm">
                  Active Customers
                  </h6> */}
                </div>
                {/* filter table data form */}
                <div className="flex items-center flex-wrap gap-1">
                  <form
                    className="filterinput"
                    action=""
                    onSubmit={handleSubmit}
                  >
                    <input
                      onChange={handleChange}
                      type="text"
                      name="inputdata"
                      value={inputdata}
                      className="bg-[#F9FBFF]  sm:px-5 max-sm:w-[68%] pl-3 2xl:py-2 py-[0.40rem] border border-gray-300  outline-none focus:ring-2 focus:ring-[#C65B1D] rounded-lg text-xs max-md:my-1"
                      placeholder="Search"
                    />
                    <button
                      type="submit"
                      className="mr-1 ml-3 cursor-pointer bg-[#C65B1D]  hover:shadow-md button text-white py-[0.4rem] 2xl:text-sm text-xs rounded-lg 2xl:px-3 px-2"
                    >
                      Search
                    </button>
                  </form>
                  {/* filter table data by ticketname */}
                  <div className="flex justify-between items-center flex-wrap">
                    <i
                      onClick={handleRefresh}
                      className="fa-solid fa-arrows-rotate ml-2 cursor-pointer border border-gray-300 px-2 2xl:py-[0.45rem] py-[0.40rem] rounded-md bg-[#F9FBFF]"
                    ></i>
                  </div>
                </div>
              </div>

              {popup && (
                <div className="fixed inset-0 top-0 left-0 w-screen h-screen z-[9999]  flex items-center justify-center bg-black bg-opacity-50">
                  <form
                    onSubmit={handlePDFupload}
                    className="bg-white border rounded-[24px]  shadow-lg border-[#C65B1D] w-[556px]   p-10 max-w-6xl"
                  >
                    <div className="text-end">
                      <i
                        onClick={() => setPopup(false)}
                        className="fa-solid fa-xmark text-lg cursor-pointer"
                      ></i>
                    </div>

                    <div className="text-center">
                      <h3 className="text-[#C65B1D] text-3xl font-medium">
                        Upload Doc
                      </h3>
                    </div>

                    <div
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      className={`border-2 border-dashed border-[#C65B1D] flex justify-center flex-col gap-4 items-center p-10 rounded-[20px] mt-10 ${
                        dragActive ? "bg-orange-50" : ""
                      } cursor-pointer`}
                    >
                      <input
                        type="file"
                        accept=".png,.jpg,.jpeg,.pdf"
                        onChange={handleFileChange}
                        className="hidden"
                        id="fileInput"
                      />
                      <label
                        htmlFor="fileInput"
                        className="text-center cursor-pointer"
                      >
                        <i className="fa-solid fa-arrow-up-from-bracket text-[#686868] text-xl"></i>
                        <h3 className="text-[22px] mt-2">
                          Drag & drop or Browse
                        </h3>
                        <p className="text-[#B5B7C0] text-sm">
                          (Only PNG, JPG, PDF files allowed.)
                        </p>
                      </label>

                      {selectedFile && (
                        <p className="text-green-700 mt-4 text-sm">
                          Selected: {selectedFile.name}
                        </p>
                      )}
                    </div>

                    <div>
                      <button
                        type="submit"
                        className="bg-[#C65B1D] w-full mt-10 p-2 rounded-lg text-white"
                      >
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              )}

              {/* section-4 table */}
              <div className="mt-6 relative overflow-x-auto  overflow-y-hidden">
                <table className="w-full border-collapse border-spacing-0">
                  <thead>
                    <tr className="text-[#b5b7c0] m-12 font-medium">
                      <th>Sr no</th>
                      <th>Customer Name</th>
                      <th>Certificate Name</th>
                      <th>Date</th>
                      <th>Order ID</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lodding ? (
                      <tr>
                        <td colSpan="11" className="text-center">
                          <div className="flex justify-center items-center w-full h-full">
                            <SyncLoader
                              margin={1}
                              speedMultiplier={1}
                              color={"#069ea1"}
                              loading={lodding}
                              size={10}
                            />
                          </div>
                        </td>
                      </tr>
                    ) : (
                      (filteredPayments.length > 0
                        ? filteredPayments
                        : records
                      ).map((tdata, index) => {
                        const serialNumber = firstIndex + index + 1;
                        const filename = tdata.selectedFile?.split("-").pop();
                        return (
                          <React.Fragment key={tdata.id}>
                            <tr
                              className="h-10 text-sm m-12 cursor-pointer font-medium"
                              style={{ cursor: "pointer" }}
                            >
                              <td>{serialNumber}</td>
                              <td>
                                {tdata.notes.first_name} {tdata.notes.last_name}
                              </td>
                              <td>{filename}</td>
                              <td>{tdata.date}</td>
                              <td className="py-4 px-6">{tdata.order_id}</td>
                              <td className="whitespace-nowrap pl-4 py-2 text-[#1A1A1A] text-sm max-xl:text-xs leading-5 font-normal border-b text-start border-gray-300">
                                {filename ? (
                                  <button
                                    onClick={() =>
                                      tdata.selectedFile &&
                                      window.open(tdata.selectedFile, "_blank")
                                    }
                                    className="text-[#B5B7C0]"
                                  >
                                    download
                                  </button>
                                ) : (
                                  <button
                                    onClick={() => {
                                      handlePopup(tdata.id);
                                    }}
                                    className="text-[#C65B1D]"
                                  >
                                    Upload
                                  </button>
                                )}
                              </td>
                            </tr>

                            {/* {expandedRowId === tdata.id && (
                              <tr>
                                <td colSpan="12">
                                  <div className="border m-1 border-gray-300 rounded-lg">
                                    <div className="flex p-5 justify-between ">
                                      <div>
                                        <h2 className="text-start text-sm mb-1 text-[#B5B7C0]">
                                          Email Id:{" "}
                                          <span className="text-black text-xs">
                                            {tdata.notes.email}
                                          </span>{" "}
                                        </h2>
                                        <h2 className="text-start text-sm mb-1 text-[#B5B7C0]">
                                          Order Id:{" "}
                                          <span className="text-black text-xs">
                                            {tdata.order_id}
                                          </span>{" "}
                                        </h2>

                                        <h2 className="text-start text-sm mb-1 text-[#B5B7C0]">
                                          Method:{" "}
                                          <span className="text-black text-xs">
                                            {tdata.method}
                                          </span>{" "}
                                        </h2>
                                      </div>
                                      <div>
                                        <div className="flex gap-5 items-center">
                                          <h2 className="text-[#B5B7C0]">
                                            OTP for ticket collection
                                          </h2>
                                          <h2 className="text-[#00A198]">
                                            Resend OTP to client
                                          </h2>
                                        </div>
                                        <form className="flex gap-2 mt-2">
                                          <input
                                            type="text"
                                            className="border rounded-md py-1 px-5"
                                          />
                                          <button className="px-5 rounded-md py-1 bg-[#ea1d8467]">
                                            Submit
                                          </button>
                                        </form>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )} */}
                          </React.Fragment>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>

              {selectedPayment && (
                <PopUP
                  currentStatus={selectedPayment.status}
                  onClose={() => setSelectedPayment(null)}
                />
              )}
              {/* pagination */}
              <div className="flex justify-between items-center mt-4">
                <button
                  onClick={prevPage}
                  disabled={currentPage === 1}
                  className={`px-4 py-2 bg-[#C65B1D] hover:bg-[#C65B1D] text-white rounded-lg mr-2 transition duration-200 ease-in-out ${
                    currentPage === 1
                      ? "opacity-50 cursor-not-allowed"
                      : "cursor-pointer"
                  }`}
                  aria-label="Previous Page"
                >
                  Prev
                </button>

                <button
                  onClick={nextPage}
                  disabled={currentPage === npage}
                  className={`px-4 py-2 bg-[#C65B1D] hover:bg-[#C65B1D] text-white rounded-lg ml-2 transition duration-200 ease-in-out ${
                    currentPage === npage
                      ? "opacity-50 cursor-not-allowed"
                      : "cursor-pointer"
                  }`}
                  aria-label="Next Page"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminCertificate;
